module.exports = __webpack_public_path__ + "img/avatar6.8d67fe24.png";